export default __webpack_public_path__ + "static/media/secondary-desktop.4b347655.png";